import { useRef } from 'react'
import { isEqual } from 'libraries/lodash'
import { Resize } from 'libraries/front-end-core/services/WindowService'
import { getBoundingClientRect, isParentOf } from 'libraries/front-end-core/helpers/document'
import { PopoverTrigger } from 'services/OverlayService'
import useBaseState from 'hooks/useBaseState'
import { partition, merge } from 'rxjs'
import { map, filter, distinctUntilChanged } from 'rxjs/operators'

const usePopover = () => {
  const containerRef = useRef()
  const [TriggerClick, TriggerHover] = partition(PopoverTrigger, i => i.persist)
  const state = merge(
    TriggerClick.pipe(
      map(i => ({ click: i?.dismiss ? [] : [i] }))
    ),
    TriggerHover.pipe(
      filter(e => !e.target || !isParentOf(containerRef.current, e.target)),
      distinctUntilChanged(isEqual),
      map(i => ({ hover: i.dismiss ? [] : [i] }))
    ),
    Resize.pipe(
      map(({ timeStamp }) => ({ resize: timeStamp }))
    )
  )
  const { baseState: { click, hover, resize } } = useBaseState(
    state,
    { click: [], hover: [], resize: 0 }
  )

  const getBoundingBox = () => getBoundingClientRect(containerRef.current)

  return { containerRef, click, hover, resize, getBoundingBox }
}

export default usePopover
